<section>
    <div class="container-fluid">
        <ol class="breadcrumb">
            <li class="breadcrumb-item">Home</li>
            <li class="breadcrumb-item">Admin</li>
            <li class="breadcrumb-item active">Email Template View</li>
        </ol>
    </div>
</section>
<section>
    <div class="container-fluid">
        <div class="row mb-2">
            <div class="col-sm-12 p-0">
                <div class="card Title-bar-blue">
                    <div class="devcare-card-header">
                        <span class="devcare-sub-header Title-bar-text"><i class="fas fa-search mr-1"></i>Email Template View</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<section>
    <div class="row">
        <div class="col-md-12">
            <div class="card">
                <div class="card-body">
                    <div class="p-grid">
                        <div class="p-md-6 p-col-12">
                            <div class="p-text-bold">Email Template Name</div>
                            {{emailTemplateDetail?.templateName}}
                        </div>
                        <div class="p-md-6 p-col-12">
                            <div class="p-text-bold">Screen Name</div>
                            {{emailTemplateDetail?.screenName}}
                        </div>
                    </div>
                    <div class="p-grid">
                        <div class="p-md-6 p-col-12">
                            <div class="p-text-bold">Subject</div>
                            {{emailTemplateDetail?.subject}}
                        </div>
                        <div class="p-md-6 p-col-12">
                            <div class="p-text-bold">Active</div>
                            <span class="customer-badge status-active" *ngIf="emailTemplateDetail.isActive">Active</span>
                                            <span class="customer-badge status-inactive" *ngIf="!emailTemplateDetail.isActive">Inactive</span>
                        </div>
                    </div>
                    <div class="p-grid">
                        <div class="p-md-12 p-col-12">
                            <div class="p-text-bold">Description</div>
                            {{emailTemplateDetail?.description}}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-md-12">
          <button pButton pRipple type="button" label="Cancel" icon="pi pi-times"
          class="p-button-sm p-button-raised p-button-danger m-2 float-right" (click)="cancel()"></button>
        </div>
    </div>
</section>




